// brand: API mínima del tenant disponible como `this.$brand` en cualquier componente.
// Se construye en RUNTIME desde `$tenantConfig` (cargado por el primer plugin runtime-config,
// que corre antes que éste). El applier ya NO hornea INTRANET_BRAND_*/INTRANET_CONTACT_* en env.

// buildBrand: puro (testeable). Construye el objeto $brand desde la config de runtime.
export const buildBrand = (config) => {
	const cfg = config || {};
	const brand = cfg.brand || {};
	const colors = cfg.colors || {};

	return Object.freeze({
		companyName: brand.companyName || "",
		shortName: brand.shortName || "",
		productName: brand.productName || "Intranet",
		website: brand.website || "",
		colors: Object.freeze({
			primary: colors.primary || "",
			secondary: colors.secondary || "",
			accent: colors.accent || "",
			themeColor: colors.themeColor || "",
		}),
	});
};

export default function brandPlugin(ctx, inject) {
	const brand = buildBrand(ctx.$tenantConfig);
	inject("brand", brand);

	// Título en runtime desde la marca (antes horneado en nuxt.config titleTemplate; se
	// neutraliza el bake en rcp-16). Se fija sólo si hay companyName.
	if (typeof document !== "undefined" && brand.companyName) {
		document.title = brand.productName
			? `${brand.companyName} · ${brand.productName}`
			: brand.companyName;
	}
}
